import { render, staticRenderFns } from "./WorkflowStateThresholdGroupFormDialog.vue?vue&type=template&id=53ed5abe&"
import script from "./WorkflowStateThresholdGroupFormDialog.vue?vue&type=script&lang=ts&"
export * from "./WorkflowStateThresholdGroupFormDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports